export default __webpack_public_path__ + "static/media/reply-naming-conventions2.9b370b1b.png";